import { BaseMonitorWs } from "./ws.base";
import {Container, Service} from "typedi";

@Service("BoxMonitorWs")
class BoxMonitorWs extends BaseMonitorWs {
}

const service: BoxMonitorWs = Container.get("BoxMonitorWs");
export default service;
